import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Markie.");
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-b border-white/20 py-3 text-white outline-none focus:border-brand-orange transition-colors placeholder:text-white/30";

  return (
    <div className="min-h-screen bg-brand-ink text-white flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-brand-orange mb-3">Promoter Access</div>
        <h1 className="font-head font-extrabold text-5xl uppercase leading-none mb-10">
          MARKIE<span className="text-brand-orange">2</span>FRESH
        </h1>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <input className={field} type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          <input className={field} type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full rounded-full bg-brand-orange text-white py-4 font-mono text-sm uppercase tracking-[0.2em] hover:bg-brand-orangeHover transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Enter dashboard →"}
          </button>
        </form>
      </div>
    </div>
  );
}
